import { Box, Chip, Paper, styled, TableCell, TableHead, Typography } from "@mui/material";

export const StyledPaper = styled(Paper)(({ theme, tabLabel }) => ({
  padding: 22,
  borderRadius: theme.borderRadius.radius.large,
  border:
    tabLabel === "Pickups" || tabLabel === "Shipments"
      ? theme.borders.warning
      : theme.borders.highlighted,
  [theme.breakpoints.down("lg")]: {
    padding: 22,
  },

  [theme.breakpoints.down("lg")]: {
    padding: 16,
  },
}));

export const HeaderBox = styled(Box)(({ theme, responsiveMode }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 16,
  marginBottom: 16,
  ...(responsiveMode
    ? {
        width: "100%",
        [theme.breakpoints.down("md")]: {
          flexDirection: "column",
          alignItems: "stretch",
        },
      }
    : {
        [theme.breakpoints.down("lg")]: {
          display: "block",
          gap: "10px",
        },
      }),
}));

export const StyledTableHead = styled(TableHead)(({ theme, tabLabel }) => ({
  backgroundColor:
    tabLabel === "Pickups" || tabLabel === "Shipments"
      ? theme.palette.custom.warning
      : theme.palette.custom.primary,

  "& .MuiTableRow-root": {
    "&:first-of-type .MuiTableCell-head:first-of-type": {
      borderTopLeftRadius: theme.borderRadius.radius.medium,
    },
    "&:first-of-type .MuiTableCell-head:last-of-type": {
      borderTopRightRadius: theme.borderRadius.radius.medium,
    },
  },
}));

export const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontWeight: theme.typography.fontWeight.medium,
}));
export const StyledTableCellBody = styled(TableCell)(() => ({
  fontSize: "16px",
  fontWeight: 500,
}));

export const ellipsisSx = {
  maxWidth: 180,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};
export const StyledTableFooter = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: 500,
  color: '#5C5C5C',
}));
export const FooterBox = styled(Box)(() => ({
  marginTop: 16,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));
export const StyledChip = styled(Chip)(({ theme, chipColor }) => ({
  backgroundColor: theme.palette.custom[chipColor] || theme.palette.grey[300],
  color: theme.palette.custom.white,
  fontWeight: 500,
}));
export const StyledButtonBox = styled(Box)(({ theme, responsiveMode }) => ({
  display: "flex",
  gap: "12px",
  alignItems: "center",
  ...(responsiveMode && {
    flexShrink: 0,
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      "& .MuiButton-root": {
        flex: "1 1 140px",
      },
    },
  }),
}));
